import { keepPreviousData, useQuery } from "@tanstack/react-query"
import usePrivateAxios from "../api/usePrivateAxios"
import { Mapper } from "../services/mapper"

type useLatestReleaseNotesProps<T> = {
  params?: {
    refetchInterval?: number | false
  }
  mapper?: (data: any) => T
}

export const useLatestReleaseNotes = <T,>({
  params: { refetchInterval = false} = {},
  mapper = Mapper.default(),
}: useLatestReleaseNotesProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = { data: {} as T, meta: {} as any },
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['releaseNotesLatest'],
    queryFn: () => {
      return privateAxios.get('/release_notes/latest')
    },
    select: (data: { data: { data: T[]; meta: any } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
    refetchInterval,
  })

  return { data, meta, isPending, ...rest }
}